import React from "react";
import { Route, Switch } from "react-router-dom";
import AdminRoute from "./AdminRoute";
import MerchantContainer from "../../containers/MerchantContainer";
import ScheduleDeliveryContainer from "../../containers/ScheduleDeliveryContainer";
import ReScheduleDeliveryContainer from "../../containers/ReScheduleDeliveryContainer";
import TaskContainer from "../../containers/TaskContainer";
import FulfillmentContainer from "../../containers/FulfillmentContainer";
import OrderContainer from "../../containers/OrderContainer";
import TimeslotContainer from "../../containers/TimeslotContainer";
import CreateMerchantProfile from "../CreateMerchantProfile";
import CreateUserProfile from "../CreateUserProfile";
import CreateDriverProfile from "../CreateDriverProfile";
import TrackerContainer from "../../containers/TrackerContainer";
import FeedbackContainer from "../../containers/FeedbackContainer";
import ClicksContainer from "../../containers/ClicksContainer";
import MessagesContainer from "../../containers/MessagesContainer";
import InquiryContainer from "../../containers/InquiryContainer";
import RouteTaskContainer from "../../containers/RouteTaskContainer";
import LogisticsTabs from "../../containers/LogisticsTabs";
import DriverContainer from "../../containers/DriverContainer";
import UserContainer from "../../containers/UserContainer";
import CustomerContainer from "../../containers/CustomerContainer";
import StatsTabShow from "../../containers/StatsTabShow";
import Landing from "../layout/Landing";
import ContactContainer from "../../containers/ContactContainer";

const Routes = () => {
  return (
    <section>
      <Switch>
        <Route exact path="/" component={Landing} />
        <Route exact path="/analytics" component={OrderContainer} />
        <AdminRoute path="/merchants/:id" component={MerchantContainer} />
        <AdminRoute path="/create-merchant" component={CreateMerchantProfile} />
        <AdminRoute path="/create-user" component={CreateUserProfile} />
        <AdminRoute path="/create-driver" component={CreateDriverProfile} />
        <AdminRoute path="/customers/:id" component={CustomerContainer} />
        <AdminRoute path="/users/:id" component={UserContainer} />
        <AdminRoute path="/drivers/:id" component={DriverContainer} />
        <AdminRoute path="/routes/:id" component={RouteTaskContainer} />
        <AdminRoute path="/trackers" component={TrackerContainer} />
        <AdminRoute path="/feedback" component={FeedbackContainer} />
        <AdminRoute path="/clicks" component={ClicksContainer} />
        <AdminRoute path="/messages" component={MessagesContainer} />
        <AdminRoute path="/inquiries" component={InquiryContainer} />
        <AdminRoute path="/logistics/:tab/:date?" component={LogisticsTabs} />
        <AdminRoute path="/stats" component={StatsTabShow} />
        <Route path="/dc/:id" component={ContactContainer} />
        <AdminRoute exact path="/tasks/:id" component={TaskContainer} />
        <AdminRoute
          exact
          path="/fulfillments/:id"
          component={FulfillmentContainer}
        />
        <AdminRoute exact path="/timeslots/:id" component={TimeslotContainer} />
        <AdminRoute
          exact
          path="/scheduleDelivery/:id"
          component={ScheduleDeliveryContainer}
        />
        <AdminRoute
          exact
          path="/rescheduleDelivery/:id"
          component={ReScheduleDeliveryContainer}
        />
      </Switch>
    </section>
  );
};

export default Routes;
